import { styled, Card, CardContent } from '@mui/material';

// eslint-disable-next-line max-len
export const AssistantGenerateRoutesDialogByTemplateContentFormTemplateSelectedDataPreAssignedDriverCardContainer =
  styled(Card)({
    display: 'grid',
    width: '100%',
  });

// eslint-disable-next-line max-len
export const AssistantGenerateRoutesDialogByTemplateContentFormTemplateSelectedDataPreAssignedDriverCardContent =
  styled(CardContent)(({ theme }) => ({
    padding: theme.spacing(1, 2),
    display: 'grid',

    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
  }));
